import React, { useState } from 'react';
import { School } from '@/services/educationService';
import { useEducationData } from '@/hooks/useEducationData';
import EducationDataDisplay from '@/components/EducationDataDisplay';
import EducationFormInline from '@/components/EducationForm/EducationFormInline';
import EducationDescriptionBox from '@/components/EducationDescriptionBox';

interface EducationModuleProps {
  className?: string;
}

const EducationModule: React.FC<EducationModuleProps> = ({ className }) => {
  const { schools, isLoading } = useEducationData();
  const [showForm, setShowForm] = useState(false);
  const [editingSchool, setEditingSchool] = useState<School | null>(null);

  const handleAddSchool = () => {
    setEditingSchool(null);
    setShowForm(true);
  };

  const handleEditSchool = (school: School) => {
    setEditingSchool(school);
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditingSchool(null);
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingSchool(null);
  };

  // If loading, show loading state
  if (isLoading) {
    return (
      <div className="education-display-loading">
        <div className="education-loading-spinner"></div>
        <p>Loading education data...</p>
      </div>
    );
  }

  // If showing form, display it
  if (showForm) {
    return (
      <div className={className}>
        <EducationFormInline
          school={editingSchool || undefined}
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
        />
      </div>
    );
  }

  // If no schools exist, show form directly
  if (schools.length === 0) {
    return (
      <div className={className}>
        <EducationFormInline
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
        />
      </div>
    );
  }

  // If schools exist, show data display
  return (
    <div className={className}>
      <EducationDataDisplay
        onAddSchool={handleAddSchool}
        onEditSchool={handleEditSchool}
      />
    </div>
  );
};

export default EducationModule;